import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import BackgroundImage from '../../atoms/BackgroundImage/BackgroundImage'
import ImageLightbox from '../../molecules/ImageLightbox/ImageLightbox'

import './PageHero.css'

import {
  PageHeroContainer,
  PageHeroInnerContainer,
  PageHeroLogoContainer,
  PageHeroLogo,
  PageHeroContentContainer,
  PageHeroContentInnerContainer,
  PageHeroTitle,
  PageHeroSubtitle,
  PageHeroDescription,
} from './PageHero.css.js';

const PageHero = ({ config, content }) => {
  const { className, backgroundColor, fontColor, isPageHero, sectionVerticalPaddingSize, showTopHorizontalLogo, showBottomVerticalLogo, titleColor, titleBackgroundColor } = config;
  const { title, subtitle, description, backgroundImage } = content;

  const renderTopLogo = () => (
    <PageHeroLogoContainer>
      <PageHeroLogo
        src={`/images/ce-montessori/logos/ce-montessori-logo-horizontal-white-text-large.png`}
        alt={`c'e Montessori - Logo`}
      />
    </PageHeroLogoContainer>
  );

  const renderBottomLogo = () => (
    <PageHeroLogoContainer>
      <PageHeroLogo
        src={`/images/ce-montessori/logos/ce-montessori-logo-vertical.png`}
        alt={`c'e Montessori - Logo`}
      />
    </PageHeroLogoContainer>
  );

  return (
    <PageHeroContainer
      backgroundColor={backgroundColor}
      className={`${className} ${isPageHero ? `relative` : ``}`}
      fontColor={fontColor}
      isPageHero={isPageHero}
    >
      {backgroundImage && (
        <BackgroundImage
          src={backgroundImage} 
          opacity={0.9}
        />
      )}

      <PageHeroInnerContainer sectionVerticalPaddingSize={sectionVerticalPaddingSize}>
        <PageHeroContentContainer isPageHero={isPageHero}>
          <PageHeroContentInnerContainer>
            {showTopHorizontalLogo && renderTopLogo()}

            {title && (
              <PageHeroTitle
                titleColor={titleColor}
                titleBackgroundColor={titleBackgroundColor}
              >
                <ReactMarkdown
                  source={title}
                  escapeHtml={false}
                />
              </PageHeroTitle>
            )}

            {subtitle && (
              <PageHeroSubtitle>
                <ReactMarkdown
                  source={subtitle}
                  escapeHtml={false}
                />
              </PageHeroSubtitle>
            )}

            {description && (
              <PageHeroDescription>
                <ReactMarkdown
                  source={description}
                  escapeHtml={false}
                />
              </PageHeroDescription>
            )}

            {showBottomVerticalLogo && renderBottomLogo()}
          </PageHeroContentInnerContainer>
        </PageHeroContentContainer>
      </PageHeroInnerContainer>

      {backgroundImage && (
        <ImageLightbox 
          photos={[backgroundImage]} 
          styles={'PageHero--ShowImage'}
          cameraColor={'black'} 
        />
      )}
    </PageHeroContainer>
  )
}

PageHero.propTypes = {
  config: PropTypes.shape({
    backgroundColor: PropTypes.string,
    className: PropTypes.string,
    fontColor: PropTypes.string,
    isPageHero: PropTypes.bool,
    sectionVerticalPaddingSize: PropTypes.oneOf([`x-large`, `large`, `medium`, `small`]),
    showTopHorizontalLogo: PropTypes.bool,
    showBottomVerticalLogo: PropTypes.bool,
    titleColor: PropTypes.string,
    titleBackgroundColor: PropTypes.string,
  }),
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    backgroundImage: PropTypes.string,
  }),
}

export default PageHero;
